export const graphConfig = {
    groupList: {
        scopes: ["Group.Read.All"],
        endpoint: "https://graph.microsoft.com/v1.0/groups"
    }
};
